export default {
  BT_HDP: "Kèo chấp",
  BT_OU: "Tài/Xỉu",
  BT_ML: "Dòng Tiền",
  BT_1X2: "1X2",
  BT_1X2HDP: "Cược 3 cách",
  BT_CS: "Tỷ số chính xác",
  BT_OE: "Lẻ/Chẵn",
  BT_DC: "Nhân đôi cơ hội",
  BT_HTFT: "Hiệp 1/ Cả trận",
  BT_FGLG: "Bàn thắng đầu/ cuối",//"Bàn thắng đầu/Bàn thắng cuối",
  BT_TG: "Tổng số bàn thắng",
  BT_OR: "Vô địch",
  BT_ORZ: "Vô địch",

  BT_ANB: "Khách không bàn thắng",
  BT_BS: "Cả hai đội/ Một đội/ Không đội nào có bàn thắng",
  BT_CL: "Không bị ghi bàn",
  BT_DNB: "Hoà không bàn thắng",
  BT_HNB: "Chủ nhà không bàn thắng",
  BT_TWTN: "Lật ngược tình thế",

  BT_HDPF: "Kèo chấp cả trận",
  BT_OUF: "Tài/Xỉu cả trận",
  BT_MLF: "Dòng tiền cả trận",
  BT_1X2F: "1X2 cả trận",
  BT_1X2HDPF: "Cược 3 cách cả trận",
  BT_CSF: "Tỷ số chính xác cả trận",
  BT_OEF: "Lẻ/Chẵn cả trận",
  BT_DCF: "Nhân đôi cơ hội cả trận",
  BT_FGLGF: "Bàn thắng đầu/Bàn thắng cuối cả trận",
  BT_TGF: "Tổng số bàn thắng cả trận",

  BT_HDPH: "Kèo chấp hiệp 1",
  BT_OUH: "Tài/Xỉu hiệp 1",
  BT_MLH: "Dòng tiền hiệp 1",
  BT_1X2H: "1X2 hiệp 1",
  BT_1X2HDPH: "Cược 3 cách hiệp 1",
  BT_CSH: "Tỷ số chính xác hiệp 1",
  BT_OEH: "Lẻ/Chẵn hiệp 1",
  BT_DCH: "Nhân đôi cơ hội hiệp 1",
  BT_FGLGH: "Bàn thắng đầu/Bàn thắng cuối hiệp 1",
  BT_TGH: "Tổng số bàn thắng hiệp 1",

  BT_HDPOU: "Kèo chấp và tài/xỉu",
  BT_PARLAY: "Xiên hỗn hợp",
  BT_FT: "Cả trận ",
  BT_1H: "Hiệp 1 ",
  BT_2H: "Hiệp 2 ",

  BT_FG: "Bàn thắng đầu",
  BT_LG: "Bàn thắng cuối",
  BT_HFG: "HF",//"Chủ nhà có bàn thắng đầu",
  BT_AFG: "AF",//"Khách có bàn thắng đầu",
  BT_HLG: "HL",//"Chủ nhà có bàn thắng cuối",
  BT_ALG: "AL",//"Khách có bàn thắng cuối",
  BT_NG: "NG",
  BT_HY: "Chủ nhà có",
  BT_HN: "chủ nhà không",
  BT_AY: "Khách có",
  BT_AN: "Khách không",
  BT_H: "Chủ nhà",
  BT_A: "Khách",
  BT_D: "Hoà",
  BT_HD_DC: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA_DC: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DA_DC: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_HH: "HH",//"Hiệp 1 chủ nhà thắng/Cả trận chủ nhà thắng",
  BT_HD: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DH: "DH",//"Hiệp 1 hoà/Cả trận chủ nhà thắng",
  BT_DD: "DD",//"Hiệp 1 hoà/Cả trận hoà",
  BT_DA: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_AH: "AH",//"Hiệp 1 khách thắng/Cả trận chủ nhà thắng",
  BT_AD: "AD",//"Hiệp 1 khách thắng/Cả trận hoà",
  BT_AA: "AA",//"Hiệp 1 khách thắng/Cả trận khách thắng",

  BT_Y: "Có",
  BT_N: "Không",

  BT_LIVE: "Trực tiếp",
  BT_HT: "Nửa giờ",
  BT_DELAYED: "Trì hoãn",
  BT_PEN: "Luân lưu",

  BT_FT1: "Cả trận chủ nhà thắng",
  BT_FT2: "Cả trận khách thắng",
  BT_FTX: "Cả trận hoà",

  BT_HT1: "Hiệp 1 chủ nhà thắng",
  BT_HT2: "Hiệp 1 khách thắng",
  BT_HTX: "Hiệp 1 hoà",

  BT_BOTH: "Cả hai đội",
  BT_ONE: "Một đội",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",

  BT_ALL: "@:ui.bet_list",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO",

  BT_OEHM: "Chẵn/Lẻ Nhà | Chẵn/Lẻ Nhà",
  BT_OEHMH: "FH. Chẵn/Lẻ Nhà | FH. Chẵn/Lẻ Nhà",
  BT_OEAW: "Chẵn/Lẻ Khách | Chẵn/Lẻ Khách",
  BT_OEAWH: "FH. Chẵn/Lẻ Khách | FH. Chẵn/Lẻ Khách",

  BS_OEHM: "FT. Chẵn/Lẻ Nhà | FT. Chẵn/Lẻ Nhà",
  BS_OEHMH: "FH. Chẵn/Lẻ Nhà | FH. Chẵn/Lẻ Nhà",
  BS_OEAW: "FT. Chẵn/Lẻ Khách | FT. Chẵn/Lẻ Khách",
  BS_OEAWH: "FH. Chẵn/Lẻ Khách | FH. Chẵn/Lẻ Khách",

  MB_OVER: "TRÊN (4,5,6)",
  MB_UNDER: "DƯỚI (1,2,3)",
  MB_ODD: "LẺ (1,3,5)",
  MB_EVEN: "CHẴN (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Cơ Hội Gấp Đôi + O/U",
  BT_DCOU: "Cơ Hội Gấp Đôi + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + O/E",
  BT_HTFTOE: "HT/FT + O/E",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Biên Độ Thắng",
  BT_WM: "Biên Độ Thắng",
  BK_H1: "Nhà 1",
  BK_H2: "Nhà 2",
  BK_H3Up: "Nhà 3+",
  BK_A1: "Khách 1",
  BK_A2: "Khách 2",
  BK_A3Up: "Khách 3+",
  BK_D: "Hòa (Không tính 0-0)",
  BK_NG: "Không Có Bàn Thắng",

  BS_ETG: "Tổng Số Bàn Chính Xác",
  BT_ETG: "Tổng Số Bàn Chính Xác",
  BS_EHTG: "Tổng Số Bàn Chính Xác Nhà",
  BT_EHTG: "Tổng Số Bàn Chính Xác Nhà",
  BS_EATG: "Tổng Số Bàn Chính Xác Khách",
  BT_EATG: "Tổng Số Bàn Chính Xác Khách",
  BS_ETGH: "FH. Tổng Số Bàn Chính Xác",
  BT_ETGH: "FH. Tổng Số Bàn Chính Xác",
  BS_EHTGH: "FH. Tổng Số Bàn Chính Xác Nhà",
  BT_EHTGH: "FH. Tổng Số Bàn Chính Xác Nhà",
  BS_EATGH: "FH. Tổng Số Bàn Chính Xác Khách",
  BT_EATGH: "FH. Tổng Số Bàn Chính Xác Khách",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "Tỷ số HT/FT",
  BS_CSHTFT: "Tỷ số HT/FT",
  BT_ETGHTFT: "Tổng Bàn HT/FT",
  BS_ETGHTFT: "Tổng Bàn HT/FT",
};